// extracted by mini-css-extract-plugin
export var actionText = "_mh-4";
export var container = "_mh-0";
export var leftSection = "_mh-1";
export var rightSection = "_mh-2";
export var settingsButton = "_mh-6";
export var settingsIcon = "_mh-7";
export var shortcut = "_mh-5";
export var shortcutGroup = "_mh-3";